<template>
  <div class="links-page-root">
    <!-- 政府機關 -->
    <section id="gov" class="container-fluid px-0 links-section">
      <div class="row align-items-start links-row">
        <!-- 左側標題欄 -->
        <div class="links-section-title-col">
          <h1 class="links-section-title-vertical">政府機關</h1>
        </div>
        
        <!-- 右側連結欄 -->
        <div class="links-section-content-col">
          <div class="links-grid">
            <a v-for="(item, idx) in govLinks" :key="'gov-'+idx" :href="item.href" class="link-card" target="_blank" rel="noopener noreferrer">
              <div class="link-media">
                <img v-if="item.image" :src="item.image" :alt="`${item.title} - 政府機關官方網站連結`" class="link-image" loading="lazy" />
              </div>
              <div class="link-title">{{ item.title }}</div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-3 mt-4">
      <div class="container text-center">
        <small>© 2025 長發地產 All Rights Reserved.</small>
      </div>
    </footer>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';

export default {
  name: 'LinksPage',
  setup() {
    useHead({
      title: '相關連結 | 政府機關與重劃資訊 - 長發地產',
      meta: [
        {
          name: 'description',
          content: '長發地產整理桃園航空城、捷運綠線、台鐵中路站等重劃區相關政府機關連結，包含國土規劃入口網、內政部地政司、桃園市政府都市發展局等官方資訊。'
        },
        {
          name: 'keywords',
          content: '政府機關連結,國土規劃,內政部地政司,桃園市政府,都市發展局,地政局,重劃資訊,航空城,捷運綠線,土地開發'
        },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: '相關連結 | 政府機關與重劃資訊' },
        { property: 'og:description', content: '整理桃園重劃區相關政府機關官方資訊' },
        { property: 'og:image', content: '/國土規劃入口網.png' },
        { name: 'twitter:card', content: 'summary' }
      ]
    });
  },
  data() {
    return {
      govLinks: [
        { 
          title: '國土規劃入口網', 
          href: 'https://nsp.tcd.gov.tw/',
          image: '/國土規劃入口網.png'
        },
        { 
          title: '內政部地政司', 
          href: 'https://www.land.moi.gov.tw/',
          image: 'https://ws.moi.gov.tw/001/Upload/400/relpic/12250/203133/e5dcdc57-e737-4a49-b520-98391bcc0b04@710x470.png'
        },
        { 
          title: '內政部營建署', 
          href: 'https://www.cpami.gov.tw/',
          image: '/內政部營建署.png'
        },
        { 
          title: '內政部國土管理署', 
          href: 'https://www.nlma.gov.tw/',
          image: '/內政部國土管理署.png'
        },
        { 
          title: '桃園市政府', 
          href: 'https://www.tycg.gov.tw/',
          image: 'https://www.flowring.com/wp-content/uploads/2022/06/logo_taoyuan.png'
        },
        { 
          title: '桃園市政府地政局', 
          href: 'https://landadm.tycg.gov.tw/',
          image: 'https://www.asia-survey.com.tw/wuri/uploadfiles/images/20230112_165341_9818.png'
        },
        {
          title: '桃園市政府都市發展局',
          href: 'https://www.nlma.gov.tw/',
          image: '/桃園市都發局.png'
        }
      ]
    }
  }
}
</script>

<style scoped>
.links-page-root {
  min-height: 100vh;
  background: #f8f9fa;
}

/* 連結區塊樣式 */
.links-section {
  margin-top: 0;
  padding-right: 0 !important;
  padding-bottom: 3rem;
  padding-top: 3rem;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}

.links-section:last-of-type {
  border-bottom: none;
}

.links-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: start;
  column-gap: 0;
}

.links-section-title-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
  min-height: 100%;
}

.links-section-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #222;
  text-align: center;
  line-height: 1.1;
  margin-top: 3rem;
}

.links-section-content-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 0;
  padding-right: 10rem !important;
  padding-left: 0 !important;
}

.links-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 2rem 0;
}

.link-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-decoration: none;
  color: inherit;
  transition: transform 0.3s ease;
}

.link-card:hover {
  transform: translateY(-5px);
}

.link-media {
  background: linear-gradient(135deg, #e9ecef, #dee2e6);
  border-radius: 12px;
  aspect-ratio: 16 / 9;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

.link-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
}

.link-card:hover .link-media {
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.2);
  filter: brightness(0.95);
}

.link-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.link-card:hover .link-title {
  color: #007bff;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .links-row {
    grid-template-columns: 1fr;
  }
  
  .links-section-title-col {
    order: 1;
    padding: 2rem 0;
  }
  
  .links-section-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 2rem;
    margin-top: 0;
  }
  
  .links-section-content-col {
    order: 2;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  
  .links-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>


